import { Component, OnInit } from "@angular/core";
import { AccountsService } from "../../services/settings-service/accounts/accounts.service";
import swal from "sweetalert2";

@Component({
  selector: "app-mortage-control",
  templateUrl: "./mortage-control.component.html",
  styleUrls: ["./mortage-control.component.css"],
})
export class MortageControlComponent implements OnInit {
  can_edit: boolean;
  allowedRoles: any[] = [];
  restrictedRoles: any[] = [];
  logs: any[] = [];
  lg: string = "lg";
  current_page: any;

  constructor(private accountService: AccountsService) {}

  ngOnInit() {
    this.getMortageControlsRoles();
    this.getLogs();
  }

  getMortageControlsRoles() {
    this.accountService.getMortageControlsRoles().subscribe(
      (res: any) => {
        this.allowedRoles = res.allowedRoles;
        this.restrictedRoles = res.restrictedRoles;
      },
      (err) => {
        swal(err.error.message, "Something went wrong", "error");
      }
    );
  }

  removeRole(item: any, list: any[]): void {
    this.can_edit = true;
    list.splice(list.indexOf(item), 1);
  }

  removeSelected(item: any, list: any[]): void {
    this.can_edit = true;
    list.splice(list.indexOf(item), 1);
  }

  getLogs(param?: any) {
    this.accountService.getMortageControlsRolesLogs(param).subscribe(
      (res: any) => {
        this.logs = res;
        console.log(res);
      },
      (err) => {
        swal(err.error.message, "Something went wrong", "error");
      }
    );
  }

  submit() {
    let payload = {
      roles: this.restrictedRoles,
    };
    this.accountService.updateMortageControlsRoles(payload).subscribe(
      (res: any) => {
        swal("Woohoo!", "Updated Successfully!", "success").then(() => {
          this.getLogs();
        });
      },
      (err) => {
        swal(err.error.message, "Something went wrong", "error");
      }
    );
  }

  pageChange(page) {
    this.current_page = page;
    this.getLogs({ page: page });
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/mortage-control/mortage-control.component.ts